import { defineComponent as _defineComponent } from 'vue'
import SelectBoxOption from '@/assets/js/models/SelectBoxOption';
import SelectBox from '@/modules/shared/components/input/SelectBox.vue';
import { computed, ref, withDefaults } from 'vue';

type Props = {
    value: any;
    label: string;
    options: SelectBoxOption[];
    placeholder?: string;
    disabled?: boolean|string;
    errors?: string[]|null;
    showErrors?: boolean;
    hint?: string;
}
type Emits = {
    (e: 'input', value: any): void;
    (e: 'change', value: any): void;
    (e: 'update:modelValue', value: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputSelect',
  props: {
    value: { default: null },
    label: null,
    options: null,
    placeholder: { default: '' },
    disabled: { type: [Boolean, String], default: false },
    errors: { default: null },
    showErrors: { type: Boolean, default: true },
    hint: { default: '' }
  },
  emits: ["input", "change", "update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'input', value: any): void;
    (e: 'change', value: any): void;
    (e: 'update:modelValue', value: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any, label: string, options: SelectBoxOption[], placeholder: string, disabled: boolean|string, errors: string[]|null, showErrors: boolean, hint: string };





const hasBeenFocusedOnce = ref<boolean>(false);

const hasErrors = computed<boolean>(() => {
    const errorsVisible = props.showErrors || hasBeenFocusedOnce.value;
    return errorsVisible && props.errors !== null && props.errors.length > 0;
});
const errorText = computed<string>(() => {
    if (!props.errors) {
        return '';
    }
    return props.errors.join(', ');
});

function onInput(event: any) {
    hasBeenFocusedOnce.value = true;
    emits('input', event);
    emits('change', event);
    emits('update:modelValue', event);
}

return { __sfc: true,props, emits, hasBeenFocusedOnce, hasErrors, errorText, onInput, SelectBox }
}

})